import { apiSlice } from './apiSlice'

export const dashboardApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPersonalDashboard: builder.query({
      query: () => ({
        url: '/api/v1/dashboard/personal',
        method: 'GET',
      }),
    }),
    getCompanyDashboard: builder.query({
      query: () => ({
        url: '/api/v1/dashboard/company',
        method: 'GET',
      }),
    }),
    getCourseProgress: builder.query({
      query: ({ id, page }) => ({
        url: `/api/v1/admin/courses/${id}/progresses/?page=${page}`,
        method: 'GET',
      }),
    }),
    exportCourseProgress: builder.query({
      query: ({ id }) => ({
        url: `/api/v1/admin/courses/${id}/export-progresses/`,
        method: 'GET',
        responseHandler: (response) => response.blob(),
      }),
    }),
    getTeamCourseProgress: builder.query({
      query: ({ page }) => ({
        url: `/api/v1/dashboard/courses-progresses/?page=${page}`,
        method: 'GET',
      }),
    }),
    exportTeamCourseProgress: builder.query({
      query: () => ({
        url: `/api/v1/admin/courses/export-progresses/`,
        method: 'GET',
        responseHandler: (response) => response.blob(),
      }),
    }),
    exportMyCourseProgress: builder.query({
      query: () => ({
        url: `/api/v1/admin/courses/export/my-courses`,
        method: 'GET',
        responseHandler: (response) => response.blob(),
      }),
    }),
  }),
})

export const {
  useGetPersonalDashboardQuery,
  useGetCompanyDashboardQuery,
  useGetCourseProgressQuery,
  useLazyExportCourseProgressQuery,
  useGetTeamCourseProgressQuery,
  useLazyExportTeamCourseProgressQuery,
  useLazyExportMyCourseProgressQuery
} = dashboardApiSlice
